import { render, staticRenderFns } from "./ProjectSingle.vue?vue&type=template&id=623517e6&"
import script from "./ProjectSingle.vue?vue&type=script&lang=js&"
export * from "./ProjectSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('623517e6')) {
      api.createRecord('623517e6', component.options)
    } else {
      api.reload('623517e6', component.options)
    }
    module.hot.accept("./ProjectSingle.vue?vue&type=template&id=623517e6&", function () {
      api.rerender('623517e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ProjectSingle.vue"
export default component.exports